import React from "react";
import { useI18n } from "@/i18n/I18nContext";
import { Globe } from "lucide-react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ compact = false, onChange }) {
    const { lang, setLang, languages } = useI18n();
    const current = languages.find((l) => l.code === lang);
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                data-testid="language-switcher"
                className="inline-flex items-center gap-2 rounded-full border border-border/70 bg-card px-3 py-1.5 text-sm font-medium transition-colors duration-200 hover:bg-secondary"
            >
                <Globe className="h-4 w-4" />
                {compact ? current?.flag : current?.label}
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="min-w-[160px]">
                {languages.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`language-option-${l.code}`}
                        onClick={() => { setLang(l.code); onChange?.(l.code); }}
                        className={l.code === lang ? "font-semibold" : ""}
                    >
                        <span className="mr-2 text-xs text-muted-foreground">{l.flag}</span>
                        {l.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
